import childrenRouter from './routers';

import Main from '@/components/main/main';
const Login = () => import('@/views/login.vue');
const Install = () => import('@/views/install.vue');
const Error401 = () => import('@/views/401.vue');

const commonRouter = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录',
      seoTitle: '机汇管家登录',
      showInMenu: false
    }
  },
  {
    path: '/install',
    name: 'install',
    component: Install,
    meta: {
      title: '安装',
      seoTitle: '机汇管家注册安装',
      showInMenu: false
    }
  },
  {
    path: '/401',
    name: '401',
    component: Error401,
    meta: {
      title: '401',
      seoTitle: '401',
      showInMenu: false
    }
  }
];
const parentRouter = [
  {
    path: '/',
    name: 'index',
    component: Main,
    meta: {
      title: '首页',
      seoTitle: '机汇管家首页',
      showInMenu: true
    },
    children: []
  }
];
parentRouter[0].children = childrenRouter
const wholeRouters = [...commonRouter, ...parentRouter];

export default wholeRouters;
